// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.eswitch_fpg_web--QuickEstimateCalculator-module--loader--mOTinpWG7m42g2Pt8w7Q {
  height: "450vh";
  display: "flex";
  justify-content: "center";
  align-items: "center";
  margin-top: 350px;
}

.eswitch_fpg_web--QuickEstimateCalculator-module--authButton--UljNrnf1O3Y0QX5tFols {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
  margin-right: 10px;
}

.eswitch_fpg_web--QuickEstimateCalculator-module--wrapper--BuUFMV9DEKHr6oowdJeJ {
  padding: 40px;
  letter-spacing: 0 !important;
  margin-top: 32px !important;
  margin-bottom: 32px !important;
  background-color: white;
}

.eswitch_fpg_web--QuickEstimateCalculator-module--h3--Nsa2BlQwuOjFzM5tEpvH,
.eswitch_fpg_web--QuickEstimateCalculator-module--h4--k6BwvRRcPIE0nSWtvgWw {
  letter-spacing: 0 !important;
  font-family: var(--fmc-font--inter);
  padding-top: 60px;
}

.eswitch_fpg_web--QuickEstimateCalculator-module--h3--Nsa2BlQwuOjFzM5tEpvH {
  margin-bottom: 32px !important;
  font-family: var(--fmc-font--ford-motion) !important;
}

.eswitch_fpg_web--QuickEstimateCalculator-module--h4--k6BwvRRcPIE0nSWtvgWw {
  margin-bottom: 20px !important;
  font-size: 24px !important;
  font-family: var(--fmc-font--inter);
}

.eswitch_fpg_web--QuickEstimateCalculator-module--h4footer--d90s9aPRAxTRZKthNbSA {
  font-family: var(--fmc-font--ford-motion) !important;
  padding-bottom: 15px;
}

.eswitch_fpg_web--QuickEstimateCalculator-module--p--bCZfvuezfysv817PzONi {
  color: var(--fds-color--gray3) !important;
  letter-spacing: 0 !important;
  font-family: var(--fmc-font--inter);
}

.eswitch_fpg_web--QuickEstimateCalculator-module--imageWrapper--YrhtqLV5t4lJhqJ6DUwp {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  font-size: 16px;
  gap: 10px;
}

.eswitch_fpg_web--QuickEstimateCalculator-module--imageWrapper--YrhtqLV5t4lJhqJ6DUwp img.eswitch_fpg_web--QuickEstimateCalculator-module--reduceOpacity--EWatHNeQfx4koytD77Iw {
  opacity: 0.5;
  padding: 16px;
  width: 256px;
  height: 170.45px;
}

.eswitch_fpg_web--QuickEstimateCalculator-module--formGrid--eyB5Ju4FsSxNVyXgLku8 {
  border-right: 1px solid #c8c9c7;
  padding-right: 24px;
}

@media (max-width: 767px) {
  .eswitch_fpg_web--QuickEstimateCalculator-module--formGrid--eyB5Ju4FsSxNVyXgLku8 {
    border-right: none !important;
    padding-right: default;
  }
}

.eswitch_fpg_web--QuickEstimateCalculator-module--footer--elt6cNI3zwijKT9kw91I {
  padding-top: 64px;
}

.eswitch_fpg_web--QuickEstimateCalculator-module--info--_Taz86oLwDrscaLd92mb {
  font-weight: 400;
}

.eswitch_fpg_web--QuickEstimateCalculator-module--buttonWrapper--CiZjhJVQsYhaAVanljmM {
  display: flex;
  justify-content: center;
  gap: 15px;
  margin-top: 20px;
}

.eswitch_fpg_web--QuickEstimateCalculator-module--subTitle--umr73mikb1CKrH6dCvvy {
  padding: 0 207px;
}

#eswitch_fpg_web--QuickEstimateCalculator-module--links--XSUKEk4i355OWdppdsQw {
  display: flex;
  justify-content: space-between;
}

.eswitch_fpg_web--QuickEstimateCalculator-module--mobileHeading--wPxHHp7njlxGAkervW03 {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  color: var(--color-ford-blue, #00095b);
  font-feature-settings: "clig" off, "liga" off;
  font-family: FordMotion;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 1px;
}

.eswitch_fpg_web--QuickEstimateCalculator-module--mrgTop25--ZhupwnnzBu4t4WKglo2E {
  margin-top: 25%;
}`, "",{"version":3,"sources":["webpack://./src/App.module.scss","webpack://./src/components/QuickEstimateCalculator/QuickEstimateCalculator.module.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,eAAA;EACA,yBAAA;EACA,qBAAA;EACA,iBAAA;ACCJ;;ADEA;EACI,gBAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;ACCJ;;AAXA;EACI,aAAA;EACA,4BAAA;EACA,2BAAA;EACA,8BAAA;EACA,uBAAA;AAcJ;;AAXA;;EAEI,4BAAA;EACA,mCAAA;EACA,iBAAA;AAcJ;;AAXA;EACI,8BAAA;EACA,oDAAA;AAcJ;;AAXA;EACI,8BAAA;EACA,0BAAA;EACA,mCAAA;AAcJ;;AAXA;EACI,oDAAA;EACA,oBAAA;AAcJ;;AAXA;EACI,yCAAA;EACA,4BAAA;EACA,mCAAA;AAcJ;;AAXA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,eAAA;EACA,SAAA;AAcJ;;AAZI;EACI,YAAA;EACA,aAAA;EACA,YAAA;EACA,gBAAA;AAcR;;AAVA;EAKI,+BAAA;EACA,mBAAA;AASJ;;AAdI;EADJ;IAEQ,6BAAA;IACA,sBAAA;EAiBN;AACF;;AAZA;EACI,iBAAA;AAeJ;;AAZA;EACI,gBAAA;AAeJ;;AAZA;EACI,aAAA;EACA,uBAAA;EACA,SAAA;EACA,gBAAA;AAeJ;;AAZA;EACI,gBAAA;AAeJ;;AAZA;EACI,aAAA;EACA,8BAAA;AAeJ;;AAZA;EACI,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,sCAAA;EACA,6CAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AAeJ;;AAZA;EACI,eAAA;AAeJ","sourcesContent":[".loader {\n    height: '450vh';\n    display: 'flex';\n    justify-content: 'center';\n    align-items: 'center';\n    margin-top: 350px;\n}\n\n.authButton {\n    margin-top: 20px;\n    display: flex;\n    justify-content: flex-end;\n    margin-right: 10px;\n}\n\n$fds-breakpoints: (\n  'fds-xs': 360px,\n  'fds-sm': 600px,\n  'fds-md': 1024px,\n  'fds-lg': 1440px,\n  'fds-xl': 1920px\n);\n\n$fds-breakpoints-max: (\n  'fds-xxs': 359px,\n  'fds-xs': 599px,\n  'fds-sm': 1023px,\n  'fds-md': 1439px,\n  'fds-lg': 1919px\n);\n\n$fds-breakpoints-landscape-max: (\n  'handheld': 480px,\n  'tablet': 1024px\n);\n\n$custom-breakPoints-max:(\n  'tablet':767px,\n  'desktop':1023px\n);\n\n$custom-breakPoints-min:(\n  'tablet':768px,\n  'desktop':1023px\n)\n\n","@import '../../App.module.scss';\n\n.wrapper {\n    padding: 40px;\n    letter-spacing: 0 !important;\n    margin-top: 32px !important;\n    margin-bottom: 32px !important;\n    background-color: white;\n}\n\n.h3,\n.h4 {\n    letter-spacing: 0 !important;\n    font-family: var(--fmc-font--inter);\n    padding-top: 60px;\n}\n\n.h3 {\n    margin-bottom: 32px !important;\n    font-family: var(--fmc-font--ford-motion) !important;\n}\n\n.h4 {\n    margin-bottom: 20px !important;\n    font-size: 24px !important;\n    font-family: var(--fmc-font--inter);\n}\n\n.h4footer {\n    font-family: var(--fmc-font--ford-motion) !important;\n    padding-bottom: 15px;\n}\n\n.p {\n    color: var(--fds-color--gray3) !important;\n    letter-spacing: 0 !important;\n    font-family: var(--fmc-font--inter);\n}\n\n.imageWrapper {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    font-size: 16px;\n    gap: 10px;\n\n    img.reduceOpacity {\n        opacity: 0.5;\n        padding: 16px;\n        width: 256px;\n        height: 170.45px;\n    }\n}\n\n.formGrid {\n    @media (max-width: map-get($custom-breakPoints-max, 'tablet')) {\n        border-right: none !important;\n        padding-right: default;\n    }\n    border-right: 1px solid #c8c9c7;\n    padding-right: 24px;\n}\n\n.footer {\n    padding-top: 64px;\n}\n\n.info {\n    font-weight: 400;\n}\n\n.buttonWrapper {\n    display: flex;\n    justify-content: center;\n    gap: 15px;\n    margin-top: 20px;\n}\n\n.subTitle {\n    padding: 0 207px;\n}\n\n#links {\n    display: flex;\n    justify-content: space-between;\n}\n\n.mobileHeading {\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    color: var(--color-ford-blue, #00095b);\n    font-feature-settings: 'clig' off, 'liga' off;\n    font-family: FordMotion;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 24px;\n    letter-spacing: 1px;\n}\n\n.mrgTop25 {\n    margin-top: 25%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loader": `eswitch_fpg_web--QuickEstimateCalculator-module--loader--mOTinpWG7m42g2Pt8w7Q`,
	"authButton": `eswitch_fpg_web--QuickEstimateCalculator-module--authButton--UljNrnf1O3Y0QX5tFols`,
	"wrapper": `eswitch_fpg_web--QuickEstimateCalculator-module--wrapper--BuUFMV9DEKHr6oowdJeJ`,
	"h3": `eswitch_fpg_web--QuickEstimateCalculator-module--h3--Nsa2BlQwuOjFzM5tEpvH`,
	"h4": `eswitch_fpg_web--QuickEstimateCalculator-module--h4--k6BwvRRcPIE0nSWtvgWw`,
	"h4footer": `eswitch_fpg_web--QuickEstimateCalculator-module--h4footer--d90s9aPRAxTRZKthNbSA`,
	"p": `eswitch_fpg_web--QuickEstimateCalculator-module--p--bCZfvuezfysv817PzONi`,
	"imageWrapper": `eswitch_fpg_web--QuickEstimateCalculator-module--imageWrapper--YrhtqLV5t4lJhqJ6DUwp`,
	"reduceOpacity": `eswitch_fpg_web--QuickEstimateCalculator-module--reduceOpacity--EWatHNeQfx4koytD77Iw`,
	"formGrid": `eswitch_fpg_web--QuickEstimateCalculator-module--formGrid--eyB5Ju4FsSxNVyXgLku8`,
	"footer": `eswitch_fpg_web--QuickEstimateCalculator-module--footer--elt6cNI3zwijKT9kw91I`,
	"info": `eswitch_fpg_web--QuickEstimateCalculator-module--info--_Taz86oLwDrscaLd92mb`,
	"buttonWrapper": `eswitch_fpg_web--QuickEstimateCalculator-module--buttonWrapper--CiZjhJVQsYhaAVanljmM`,
	"subTitle": `eswitch_fpg_web--QuickEstimateCalculator-module--subTitle--umr73mikb1CKrH6dCvvy`,
	"links": `eswitch_fpg_web--QuickEstimateCalculator-module--links--XSUKEk4i355OWdppdsQw`,
	"mobileHeading": `eswitch_fpg_web--QuickEstimateCalculator-module--mobileHeading--wPxHHp7njlxGAkervW03`,
	"mrgTop25": `eswitch_fpg_web--QuickEstimateCalculator-module--mrgTop25--ZhupwnnzBu4t4WKglo2E`
};
export default ___CSS_LOADER_EXPORT___;
